import { render } from "./PersonaEditPersona.vue?vue&type=template&id=77d6e34c&scoped=true"
import script from "./PersonaEditPersona.vue?vue&type=script&lang=js"
export * from "./PersonaEditPersona.vue?vue&type=script&lang=js"

import "./PersonaEditPersona.vue?vue&type=style&index=0&id=77d6e34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d6e34c"]])

export default __exports__